import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@devhop/ui";
import { ChevronsUpDown } from "lucide-react";
import type * as React from "react";

export type TeamSwitcherTeam = {
  name: string;
  logo: React.ElementType;
  plan: string;
  /** ລະບົບປັດຈຸບັນ — ໃຊ້ເປັນ React key ບໍ່ຊ້ອງກັນ */
  system?: string;
};

type TeamSwitcherProps = {
  teams: TeamSwitcherTeam[];
  activeTeam: TeamSwitcherTeam;
  onTeamChange: (team: TeamSwitcherTeam) => void;
};

export function TeamSwitcher({
  teams,
  activeTeam,
  onTeamChange,
}: TeamSwitcherProps) {
  const { isMobile } = useSidebar();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                <activeTeam.logo className="size-4" />
              </div>
              <div className="grid flex-1 text-start text-sm leading-tight">
                <span className="truncate font-semibold">
                  {activeTeam.name}
                </span>
                <span className="truncate text-xs">{activeTeam.plan}</span>
              </div>
              <ChevronsUpDown className="ms-auto" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
            align="start"
            side={isMobile ? "bottom" : "right"}
            sideOffset={4}
          >
            <DropdownMenuLabel className="text-muted-foreground text-xs">
              ລະບົບ
            </DropdownMenuLabel>
            {teams.map((team) => (
              <DropdownMenuItem
                key={team.system ?? team.name}
                onClick={() => onTeamChange(team)}
                className="gap-2 p-2"
              >
                <div className="flex size-6 items-center justify-center rounded-sm border">
                  <team.logo className="size-4 shrink-0" />
                </div>
                <div className="grid flex-1">
                  <span className="font-medium">{team.name}</span>
                  <span className="text-muted-foreground text-xs">
                    {team.plan}
                  </span>
                </div>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
